export const getCustomWindowObject = (windowVariableKey: string) => {
  return windowVariableKey.split('.').reduce((cur, key: string) => cur[key as keyof Window], window) as unknown;
};

export const setCustomWindowObject = (path: string, value: unknown) => {
  const pList = path.split('.') as Array<keyof Window>;
  const key = pList.pop() as keyof Window;
  const pointer = pList.reduce((accumulator, currentValue) => {
    if (accumulator[currentValue] === undefined) (accumulator[currentValue] as unknown) = {};

    return accumulator[currentValue];
  }, window);

  (pointer[key] as unknown) = value;

  return window;
};
